import React, {Component} from 'react'
import Helmet from "react-helmet";
import Logo from "../../assets/images/mobile-logo.png";
import {Input,Button} from "antd";
import queryString from "query-string";
class SubscribeBoxSearch extends Component {
    state={
        bt_disabled:true,
        boxNo:"",
    }

    boxInputOnChange=(e)=>{
        const { value } = e.target;
        this.setState({
            boxNo:value,
            bt_disabled:!value,
        })
    }
    search=()=>{
        let boxNos = this.state.boxNo
        let boxArr = boxNos.split(/,|，|;|；|\n|\//)
        for(let i=0;i<boxArr.length;i++){
            boxArr[i] = boxArr[i].trim()
        }
        boxNos = boxArr.join(",")
        this.props.history.push("/sub/box/search/"+boxNos)
    }

    render() {
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网铁"
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                <div className='subscribe'>
                    <div className='subscribe-title'>
                        集装箱号查询
                    </div>
                    <div style={{paddingTop:20}}>
                        <Input size="large" onChange={this.boxInputOnChange} placeholder="请输入所需关注的集装箱号" onPressEnter={this.search}/>
                    </div>
                </div>
                <Button className='subscribe-footer' disabled={this.state.bt_disabled} onClick={this.search}>
                    查询
                </Button>
            </div>

        )
    }
}
export default SubscribeBoxSearch